import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiState } from '../../models/generics';

export type TLocation = {
  cityId?: number;
  pincode?: number;
  cityName: string;
};

export interface ILocationStoreState {
  selectedLocationSyncState: ApiState;
  selectedLocation: TLocation;
  isLocationSelectorOpen: boolean;
}

// Define initial state
const initialState: ILocationStoreState = {
  selectedLocationSyncState: ApiState.LOADING,
  selectedLocation: {
    pincode: undefined,
    cityId: undefined,
    cityName: "",
  },
  isLocationSelectorOpen: false
};

// Create the location slice
const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    openLocationSelector: (state) => {
      state.isLocationSelectorOpen = true;
    },
    closeLocationSelector: (state) => {
      state.isLocationSelectorOpen = false;
    },
    locationLoading: (state) => {
      state.selectedLocationSyncState = ApiState.LOADING;
    },
    locationSuccess: (state, action: PayloadAction<TLocation>) => {
      state.selectedLocation = action.payload;
      state.selectedLocationSyncState = ApiState.COMPLETED;
    },
    locationFailure: (state) => {
      state.selectedLocationSyncState = ApiState.FAILED;
    }
  }
});

export const { 
  openLocationSelector, 
  closeLocationSelector, 
  locationLoading, 
  locationSuccess, 
  locationFailure 
} = locationSlice.actions;

export const selectLocation = (state: { location: ILocationStoreState }) => state.location;

export default locationSlice.reducer;